
import moment from "moment";
import React, {useState, useEffect} from "react";
import { getOverallparticularLead } from "../../../Marketing/maketingComponents/actioncreator";
import LoanApplyContainerDis from '../../ApplicationLeads/disburseDate.container'
function LeadParticulars({ admin, newDataBackground, allStatus, payload, applyFilter, clearApplyFilter,dateTypeValue }) {
    const [pageNo, setpageNo] = useState(1);
    const [dateType, setdateType] = useState(dateTypeValue);
    const [loanDate, setLoanDate] = useState('');
    const [viewTab, setViewTab] = useState('particular');

    const [noOfEntry, setnoOfEntry] = useState(10);

    const [data, setLeadParticularData] = useState('')

    useEffect(() => {
        particularleadData()
    }, [])

    useEffect(() => {
        if(applyFilter == true){
            particularleadData()
        }
        if(dateTypeValue){
            handleType(dateTypeValue)
        }
    }, [applyFilter,dateTypeValue])

    const handleType = (data) => {
        setdateType(data)
        getOverallparticularLead(
            payload,
            pageNo,
            noOfEntry,
            data,
            (callBack) => {
                setLeadParticularData(callBack);
                clearApplyFilter()
            },
            (error) => {
                console.log(error);
            }
        );
    }
    const particularleadData = () => {
        getOverallparticularLead(
            payload,
            pageNo,
            noOfEntry,
            dateType,
            (callBack) => {
                setLeadParticularData(callBack);
                clearApplyFilter()
            },
            (error) => {
                console.log(error);
            }
        );
    }

    const details = (date) => {
        console.log(date)
        setLoanDate(date)
        // setTimeout(() => {
        setViewTab('leads')
        // }, 1000);
    }
    return (
        <>
            {viewTab === 'particular' ?
                <div style={{marginBottom:'10px'}}>
                    <div className="" style={{ marginTop:window.innerWidth > 1800 ? "60px" :'30px',marginBottom: '20px',  borderRadius: '16px', minHeight: '250px',boxShadow:'0px 2px 6px 4px rgba(50, 71, 92, 0.02), 0px 2px 9px 0px rgba(50, 71, 92, 0.04), 3px 4px 4px 0px rgba(0, 0, 0, 0.25)' }}>
                        <div className="bg-white p-4 " style={{ padding: '20px 20px' }}>
                            <h5 style={{ color: '#1d3557', fontWeight: '700' }}> <strong style={{ paddingTop: '10px' }}>Lead Particulars</strong></h5>
                            {dateType === 'apply' ?
                                <div className='credit-table' style={{ fontSize: '12px',height: window.innerWidth > 1800 ?  "600px" :'300px',overflowY:'auto' }} >
                                    <table>
                                        <thead style={{ position:'sticky',top:'0' }}>
                                            <tr className="thead-class">
                                                <th className="">
                                                    <b>
                                                        <b>Date</b>
                                                    </b>
                                                </th>
                                                <th className="">
                                                    <b>Fresh Leads</b>
                                                </th>
                                                <th className="">
                                                    <b>Fresh Approval</b>
                                                </th>
                                                <th className="">
                                                    <b>Fresh Disbursement</b>
                                                </th>

                                                <th className="">
                                                    <b>Total Spent</b>
                                                </th>
                                                <th className="">
                                                    <b>Repeat Leads</b>
                                                </th>
                                                <th className="">
                                                    <b>Repeat Approval</b>
                                                </th>
                                                <th className="">
                                                    <b>Repeat Disbursement</b>
                                                </th>
                                                <th className="">
                                                    <b>Total Leads</b>
                                                </th>
                                                <th className="">
                                                    <b>Amount Disbursed</b>
                                                </th>

                                            </tr>
                                        </thead>
                                        <tbody>
                                            {Array.isArray(data) && data.length > 0 ?
                                                data.map((data1, i) => {
                                                    return (
                                                        <tr style={{ borderBottom: "none", fontWeight: '400' }}>

                                                            <td scope="col">
                                                                {data1.loanApplyDate ? moment(data1.loanApplyDate).format('DD-MM-YYYY') : ''}
                                                            </td>
                                                            <td scope="col">
                                                                {data1.totFreshCount}
                                                            </td>
                                                            <td scope="col">
                                                                {data1.totFreshApprovalCount}
                                                            </td>
                                                            <td scope="col">
                                                                {data1.totFreshDisbursalAmount}
                                                            </td>

                                                            <td scope="col">
                                                                {data1.spent}
                                                            </td>
                                                            <td scope="col">
                                                                {data1.totRepeatCount}
                                                            </td>
                                                            <td scope="col">
                                                                {data1.totRepeatApprovalCount}
                                                            </td>
                                                            <td scope="col">
                                                                {data1.totRepeatDisbursalAmount}
                                                            </td>
                                                            <td scope="col">
                                                                {data1.totalCount}
                                                            </td>
                                                            <td scope="col">
                                                                {data1.totDisburseAmount}
                                                            </td>


                                                        </tr>
                                                    )
                                                }) : ""}

                                        </tbody>
                                    </table>
                                </div>
                                : ""}
                            {dateType === 'disburseDate' ?
                                <div className='credit-table' style={{ fontSize: '12px',height: window.innerWidth > 1800 ?  "600px" :'300px',overflowY:'auto' }} >
                                    <table>
                                        <thead style={{ position:'sticky',top:'0' }}>
                                            <tr className="thead-class">
                                                <th>Leads</th>
                                                <th className="">
                                                    <b>
                                                        <b> Disbursement Date</b>
                                                    </b>
                                                </th>
                                                <th className="">
                                                    <b>Fresh Count</b>
                                                </th>
                                                <th className="">
                                                    <b>Fresh Amount </b>
                                                </th>
                                                <th className="">
                                                    <b>Repeat Count</b>
                                                </th>

                                                <th className="">
                                                    <b>Repeat Amount</b>
                                                </th>
                                                <th className="">
                                                    <b>Total Count</b>
                                                </th>
                                                <th className="">
                                                    <b>Total Amount </b>
                                                </th>



                                            </tr>
                                        </thead>
                                        <tbody>
                                            {Array.isArray(data) && data.length > 0 ?
                                                data.map((data1, i) => {
                                                    return (
                                                        <tr style={{ borderBottom: "none", fontWeight: '400' }}>
                                                            <td scope="col">
                                                                <i className="fa fa-info" style={{ cursor: 'pointer' }} onClick={() => details(moment(data1.loanDisbursementDate).format('DD-MM-YYYY'))}></i>
                                                            </td>
                                                            <td scope="col">
                                                                {data1.loanDisbursementDate ? moment(data1.loanDisbursementDate).format('DD-MM-YYYY') : ''}
                                                            </td>
                                                            <td scope="col">
                                                                {data1.totDisburseAmount}
                                                            </td>
                                                            <td scope="col">
                                                                {data1.totFreshDisbursalCount}
                                                            </td>
                                                            <td scope="col">
                                                                {data1.totFreshDisbursalAmount}
                                                            </td>

                                                            <td scope="col">
                                                                {data1.totRepeatDisbursalCount}
                                                            </td>
                                                            <td scope="col">
                                                                {data1.totDisburseCount}
                                                            </td>
                                                            <td scope="col">
                                                                {data1.totRepeatDisbursalAmount}
                                                            </td>



                                                        </tr>
                                                    )
                                                }) : ""}

                                        </tbody>
                                    </table>
                                </div> : ""}
                        </div>
                    </div>
                </div>
                : ""}
            {viewTab === 'leads' ?
                <div className="background-blur">

                    <div className="popup-main  container-fluid  " style={{ padding: '', borderRadius: '10px', width: '98%', overflow: 'scroll', height: '90%', maxWidth: '95%' }}>
                        <i onClick={() => setViewTab('particular')} style={{ float: "right", marginTop: '-18px', marginRight: '-17px', fontSize: '20px', color: 'red', cursor: 'pointer' }} className="fa fa-times-circle"></i>
                        <LoanApplyContainerDis loanDate={loanDate} admin={admin} allStatus={allStatus} newDataBackground={newDataBackground} />
                    </div>
                </div>
                : ""}
        </>
    );
}

export default LeadParticulars;
